<template>
    <div class="ksBox">
        <div class="searchItem flex fle-item flex-just">
            <div class="item">
                <el-input
                        class="mr10"
                        placeholder="产品名称"
                        v-model="gsinput"
                        clearable>
                </el-input>
                <el-input
                        class="mr10"
                        placeholder="产地"
                        v-model="location"
                        clearable>
                </el-input>
                <el-input
                        class="mr10"
                        placeholder="厂家"
                        v-model="company"
                        clearable>
                </el-input>
            </div>
            <!--<el-select class="mr10" style="width: 90px" v-model="state" placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>-->
            <div class="item">
                <span class="searchName">同步时间:</span>
                <template>
                    <div class="block tbBox" >
                        <el-date-picker style="width: 100%" clearable
                                        v-model="create_date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </template>
            </div>
            <el-button type="primary" @click="searchData">检索</el-button>
            <div class="item-right flex">
                <!--<div class="uploadFile">
                    <el-button type="info" class="uploadBtn">上传文件</el-button>
                    <input  type="file" name="files" value="" id="uploadfile2" multiple="multiple" accept=".xls"
                            class="upload-input uploadfile1" @change="importFile">
                </div>-->
                <div class="xz">
                    <el-button type="primary" @click="addPro">新增</el-button>
                    <el-button type="primary" @click="allDingYue()">查看订阅</el-button>
                </div>
            </div>
        </div>
        <!--表格-->
        <div class="dataTable mt20">
            <template>
                <el-table
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        height="645"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            align="center"
                            type="selection"
                            width="45">
                    </el-table-column>
                    <el-table-column
                            prop="i_id"
                            align="center"
                            label="ID"
                            width="70">
                    </el-table-column>
                    <el-table-column
                            prop="vc_name"
                            align="center"
                            label="名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width=""
                            prop="vc_nickname"
                            align="center"
                            label="别名"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width=""
                            prop="vc_ename"
                            align="center"
                            label="英文名"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="vc_bzstyle"
                            align="center"
                            label="包装规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="vc_bzunit"
                            align="center"
                            label="包装单位"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="f_weight"
                            align="center"
                            label="单件净重"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="vc_djunit"
                            align="center"
                            label="件重单位"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="55"
                            prop="vc_unit"
                            align="center"
                            label="计量单位"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="55"
                            prop="f_bl"
                            align="center"
                            label="转换比率"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_cd"
                            align="center"
                            label="产地"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_gykh"
                            align="center"
                            label="厂家"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width=""
                            prop="vc_type"
                            align="center"
                            label="货物性质"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="file_path"
                            align="center"
                            label="图片"
                            show-overflow-tooltip>
                        <template  slot-scope="scope" >
                            <div style="height: 50px;width: 50px;display: inline-block;vertical-align: middle;">
                                <img style="height: 50px;width: 50px" :src="scope.row.file_path"  v-if="scope.row.file_path!=''"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="isjian"
                            align="center"
                            label="是否计件"
                            show-overflow-tooltip>
                        <template   slot-scope="scope">
                            <span>
                                {{scope.row.isjian==1?'是':'否'}}
                            </span>
                        </template>

                    </el-table-column>
                    <el-table-column
                            width="95"
                            prop="i_type"
                            align="center"
                            label="散水/非散水"
                            show-overflow-tooltip>
                        <template   slot-scope="scope">
                            <span>
                                {{scope.row.i_type==1?'非散水':'散水'}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="95"
                            prop="isec"
                            align="center"
                            label="是否传电商"
                            show-overflow-tooltip>
                        <template   slot-scope="scope">
                            <span>
                                {{scope.row.isec==1?'是':'否'}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="dt_createtime"
                            align="center"
                            label="时间"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作"
                            width="110">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" style="color: #67C23A"  @click="DingYue(scope.row)">查看订阅</el-button>
                            <el-button type="text" size="small" style="color: #409EFF"  @click="editData(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tableBottom flex fle-item flex-just mt20">
                    <div class="tbLeft">
<!--                        <el-button type="primary">批量发布</el-button>-->
<!--                        <el-button type="primary">批量冻结</el-button>-->
                    </div>
                    <div class="tbRight">
                        <div class="paginationBox textRig" >
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @current-change="pageCurrentChange"
                                    :current-page.sync="currentPage"
                                    :total="tableTotal">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <!--新增dialog-->
        <el-dialog :title="title"  :visible.sync="dialogFormVisibleEdit" v-if="dialogFormVisibleEdit" @close="cancelEdit" :close-on-click-modal="false" width="900px" height="500px" append-to-body>
            <adddialog :adddialogdata="adddialogdata" @cancelEdit="cancelEdit" @getMDSysMessage="getMDSysMessage"></adddialog>
        </el-dialog>
        <!--查看订阅dialog-->
        <el-dialog
            title="查看订阅"
            :visible.sync="dialogFormVisibleData"
            width="80%"
            append-to-body>
            <sub-scribe  v-if="dialogFormVisibleData" :subscribe="subscribe"></sub-scribe>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {filerequest_url} from './api';
    import {mapActions} from "vuex";
    import adddialog from "./adddialog"
    import SubScribe from "./SubScribe"
    export default {
        name: "AddSpecification",
        components:{adddialog,SubScribe},
        props:{
            specification:{
                type:Object,
                required:true,
            },

        },
        data(){
            return{
                title:"",
                dict:[],
                value1:"",
                things:[],
                value2:"",
                usetitle:"",
                addlist:{},
                subscribeData:[],
                subscribedialogVisible:false,
                editdialogVisible:false,
                labelPosition: 'right',
                isSee:true,
                rules: {
                    vc_name: [
                        { required: true, message: '商品名称', trigger: 'blur' },
                    ]
                },
                product:"",
                location:"",
                company:"",
                adddialogdata:{},
                isInput:false,
                state:"",
                create_date:"",
                options: [{
                    value: '002',
                    label: '已发送'
                }, {
                    value: '003',
                    label: '异常'
                }],
                isShow:false,
                dialogFormVisibleData:false,
                dialogFormVisibleEdit:false,
                gsinput:"",
                subscribe:{},
                fileName:"",
                fileType:"",
                fileUrl:"",
                value:"",
                i_uid:"",
                tableData: [],
                tableTotal:0,
                pageSize:1,
                currentPage:1,
                i_id:"",
                currentRow: null,
                file_path:"",
                name:"",
            }
        },
        watch:{
            specification:{
                handler:function (val) {
                    this.val=val || {};
                    this.i_id=val.i_id;
                    this.name=val.name;
                    //console.log(val,"-------------")
                },
                deep:true,
            }
        },
        mounted() {
            this.getMDSysMessage();
            console.log(this.specification,"-------------")
            this.i_id=this.specification.i_id;
            this.name=this.specification.name;
        },

        methods:{
            ...mapActions(["getCurrentMenuId"]),
            async getMDSysMessage(pageSize){
                //console.log("------------------",pageSize)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                if(pageSize!=undefined) {
                    //console.log(pageSize,"addddd")
                    this.currentPage=pageSize;
                    this.pageSize=pageSize;
                }
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:{
                        vc_name:this.gsinput,
                        vc_cd:this.location,
                        vc_gykh:this.company,
                        vc_bzstyle: "",
                        f_weight: "",
                        vc_unit:"",
                    },
                    //vc_state:this.state,
                    data_type: "product",
                    i_id:this.i_id,
                };
                //console.log(param)
                let res=await API.getMDSysMessage(param);
                if(res.code==1){
                        // console.log("zhu")
                        this.tableData= res.data;
                        this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            //检索
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                this.getMDSysMessage();
            },

            //新增
            addPro(){
                this.title="新增规格";
                this.adddialogdata={
                    i_id:0,
                    value:{
                        vc_name:this.name,
                        file_path: "",
                        isjian: 0,
                        isec: 0,
                        i_type:0,
                        isusepack:0,
                        i_pzid_js:0,
                        i_pzid_kcjs:0,
                        f_bl:1,
                        vc_unit:'吨',
                        i_flag:this.specification.i_flag,
                    },
                    pid:this.i_id,
                    title:"新增规格",
                    pageSize:1
                };
                this.dialogFormVisibleEdit=true;
            },
            //编辑
            editData(value,index){
                this.title="编辑规格";
                this.adddialogdata={
                    vc_name:value.vc_name,
                    i_id:value.i_id,
                    pid:value.pid,
                    value:value,
                    title:"编辑规格",
                    pageSize:this.pageSize
                };
                this.dialogFormVisibleEdit=true;
            },
            cancelEdit(){
                this.adddialogdata={};
                this.dialogFormVisibleEdit=false;
            },

            //查看订阅
            DingYue(value){
                this.isShow=false;
                this.dialogFormVisibleData=true;
                this.subscribe=value;

            },
            allDingYue(value){
                this.isShow=true;
                this.dialogFormVisibleData=true;
                this.subscribe={
                    i_id:this.i_id,
                    isShow:this.isShow,
                };
            },
            State(row, column, cellValue, index){
                if(row.i_state==='001'){
                    return '发送中'
                }else if(row.i_state==='002'){
                    return '已发送'
                }else if(row.i_state==='003'){
                    return '异常'
                }
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                this.getMDSysMessage();
            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val)
            },

        },
    }
</script>

<style lang="scss"  scoped>
    .flex{
        display: flex;
    }
    .fle-item{
        align-items: center;
    }
    .flex-just{
        justify-content: space-between;
    }
    .mr10{
        margin-right: 10px;
    }
    .mt20{
        margin-top: 20px;
    }

    .mrl10{
        margin-left: 10px;
    }

    .mrb10{
        margin-bottom: 10px;
    }
    .ksBox{
        height: 100%;
        margin-top: 20px;
    }
    .searchItem{
        .item{
            width: 30%;
            /deep/{


            }
        }
        .item-right{
            margin-right: 40px;
            .xz{
                margin-left: 10px;
            }
        }
    }
    .uploadFile{
        /*height: 80px;*/
        overflow: hidden;
        position: relative;
        .uploadBtn{
            width: 150px;
        }
        .upload-input{
            width: 150px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }
    .dataSpan{
        width: 100px;
        display: inline-block;
        padding-top: 10px;
    }
    .backColor{
        color: #606266;
    }
    .redColor{
        color: red;
    }
    /deep/{
        .el-dialog{
            font-size: 20px;
        }
        .el-dialog__header{
            background-color: #3e82e8;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table td, .el-table th{
            padding: 5px 0;
        }
    }

    .upload-input {
        position: absolute;
        opacity: 0;
        width: 70px;
        height: 80px;
    }

</style>